import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.AyGauy',
    defaultMessage: 'Login',
  },
  description: {
    id: 'studio.G3pGoD',
    defaultMessage: 'Login to Appsemble',
  },
  loginWith: {
    id: 'studio.VVEa+s',
    defaultMessage: 'Login with {name}',
  },
});
